module.exports = __webpack_public_path__ + "static/img/kjdy08.f8a0715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy08.png
// module id = 131
// module chunks = 0